export default __webpack_public_path__ + "static/whatsapp-icon-bb0e639682a2a00054e82c372d956b88.png";